import React from "react";

import { useParams } from "react-router-dom";

import Conprof from "src/organization/pages/project/environment/metrics/profiling/components/Conprof/Conprof";

const View = () => {
  const { appName = "" } = useParams<{ appName: string }>();

  return <Conprof service={appName} />;
};

export default View;
